import { useNavigate } from '@tanstack/react-router';
import { DataTable } from '@/components/data-table/data-table';
import { DataTableFilterMenu } from '@/components/data-table/data-table-filter-menu';
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options';
import { cn } from '@/lib/utils';
import { useLotSizingsTable } from './hooks/use-lot-sizings-table';

export function LotSizingsTable() {
  const navigate = useNavigate();

  const { table, isPending } = useLotSizingsTable();

  return (
    <div
      className={cn(
        'relative flex min-h-0 flex-1 flex-col',
        isPending && 'pointer-events-none',
      )}
    >
      {isPending && (
        <div className='absolute inset-0 z-20 animate-pulse rounded-md bg-muted/40' />
      )}
      <DataTable
        className={cn('min-h-0', isPending && 'opacity-60')}
        onRowClick={(row) =>
          navigate({ to: '/lot-sizing/$id', params: { id: row.original.id } })
        }
        table={table}
      >
        <div
          className='flex w-full items-start justify-between gap-2 p-1'
          role='toolbar'
        >
          <div className='flex flex-1 flex-wrap items-center gap-2'>
            <DataTableFilterMenu table={table} />
          </div>
          <DataTableViewOptions align='end' table={table} />
        </div>
      </DataTable>
    </div>
  );
}
